
export const localizer = {
  id: "common.id",
  row: "common.row",
  operation: "common.operation",
  name: "common.name",
  parentName: "common.parentName",
  key: "common.key",
  value: "common.value",
  title: "common.title",
  text: "common.text",
  price: "common.price",
  privateNumber: "common.privateNumber",
  parent: "common.parent",
  number: "common.number",
  group: "common.group",
  active: "common.active",
  setting: "common.setting",
  public: "common.public",
  user: "common.user",
  mobile: "common.mobile",
  description: "common.description",
  credit: "common.credit",
  authenticated: "common.authenticated",
  amount: "common.amount",
  admin: "common.admin",
  authenticatedMobile: "common.authenticatedMobile",
  activeSend: "common.activeSend",
  userName: "common.userName",
  userId: "common.userId",
  createDate: "common.createDate",
  lastModified: "common.lastModifiedDate",
  expireDate: "common.expireDate",
  organization: "common.organization",
  domain: "common.domainName",
  status: "common.status",
  minPrice: "common.minPrice",
  maxPrice: "common.maxPrice",
  startDate: "common.startDate",
  endDate: "common.endDate",
  typeBank: "common.typeBank",
  account: "common.account",
  firstName: "common.firstName",
  lastName: "common.lastName",
  birthDate: "common.birthDate",
  creator: "common.creator",
  nameFa: 'common.nameFa',
  nameEn: 'common.nameEn',
  CustomFieldTypes: 'common.CustomFieldTypes',
  documentation: 'common.documentation',
  default: 'common.isDefault',
  isAuthenticatedMobile: 'common.isAuthenticatedMobile',
  organizationName: 'common.organizationName',
  isForeigner: 'common.isForeigner',
  parentOrganization: "common.parentOrganization",
  format: "common.format",
  organizationCredit: "common.organizationCredit",
  smsText: "common.smsText",
  sendType: "common.sendType",
  senderNumber: "common.senderNumber",
  resellerName: "common.resellerName",
  sendSubType: "common.sendSubType",
  lockOut: "common.lockOut",
  receiveDateTime: "common.receiveDateTime",
}
